import yup from "../../../../utils/yup-extended";
import {
  createSessionBasicFormStepFormValidationSchema,
  CreateSessionBasicFormStepFormValues,
} from "../../createService/multi-step/basic-form/schema-validation";
import {SessionSettingsFormFieldsType} from "../../../../components/offering-form/session-bundle/session/settings/types";
import {CoverImagesItemResponse} from "../../../../react-query-hooks/products/types";
export const editSessionBasicFormStepFormValidationSchema =
  createSessionBasicFormStepFormValidationSchema.shape({
    isPaused: yup.bool().default(false),
    cover_images: yup
      .array()
      .default([])
      .max(5, "You can only add a maximum of 5 images"),
  });

export type EditSessionBasicFormStepFormValuesYup = yup.InferType<
  typeof editSessionBasicFormStepFormValidationSchema
>;

export type EditSessionBasicFormStepFormValues = CreateSessionBasicFormStepFormValues &
  SessionSettingsFormFieldsType & {
    cover_images: CoverImagesItemResponse[];
  };
